/**
 * 时钟
 *
 * @author 张卓诚
 * @export
 * @class Clock
 */
export class Clock {
    constructor(time) {
        /**
         * 总时间
         *
         * @memberof Clock
         */
        this.time = 0;
        /**
         * 归档的已过去时间
         *
         * @memberof Clock
         */
        this.elapse = 0;
        /**
         * 播放开始于
         *
         * @type {(number | null)}
         * @memberof Clock
         */
        this.startedAt = null;
        /**
         * 播放中
         *
         * @memberof Clock
         */
        this.playing = false;
        /**
         * 定时器
         *
         * @type {(number | null)}
         * @memberof Clock
         */
        this.timer = null;
        /**
         * 订阅者
         *
         * @memberof Clock
         */
        this.subscription = [];
        /**
         * 时钟向前走
         *
         * @memberof Clock
         */
        this.clock = () => {
            if (this.playing) {
                if (this.getTime() >= this.time) {
                    this.stop();
                }
                else {
                    this.dispatch("elapse");
                    this.timer = window.requestAnimationFrame(this.clock);
                }
            }
            this.timer = null;
        };
        this.time = time;
        this.elapse = 0;
    }
    /**
     * 播放
     *
     * @author 张卓诚
     * @memberof Clock
     */
    play() {
        // tslint:disable-next-line: early-exit
        if (this.startedAt === null) {
            this.playing = true;
            this.startedAt = new Date().getTime();
            // 防止重复创建循环
            if (this.timer === null) {
                this.clock();
            }
            this.dispatch("play");
        }
    }
    /**
     * 暂停
     *
     * @author 张卓诚
     * @returns
     * @memberof Clock
     */
    isPlaying() {
        return this.playing;
    }
    /**
     * 分发事件
     *
     * @author 张卓诚
     * @memberof Clock
     */
    dispatch(eventName) {
        const elapse = this.getTime();
        this.subscription.forEach((callBack) => { callBack(eventName, elapse, this.time); });
    }
    /**
     * 订阅
     *
     * @author 张卓诚
     * @param {(eventName: EventName, elapse: number, time: number) => any} callBack
     * @returns
     * @memberof Clock
     */
    subscribe(callBack) {
        this.subscription.push(callBack);
        return () => {
            this.subscription.splice(this.subscription.indexOf(callBack), 1);
        };
    }
    /**
     * 暂停
     *
     * @author 张卓诚
     * @memberof Clock
     */
    pause() {
        if (this.startedAt !== null) {
            this.playing = false;
            // 将时间归档，模拟时间暂停
            this.elapse = new Date().getTime() - this.startedAt + this.elapse;
            this.startedAt = null;
            this.dispatch("pause");
        }
    }
    /**
     * 重置
     *
     * @author 张卓诚
     * @memberof Clock
     */
    reset() {
        this.elapse = 0;
        this.startedAt = null;
        this.playing = false;
        this.dispatch("reset");
    }
    /**
     * 停止
     *
     * @author 张卓诚
     * @memberof Clock
     */
    stop() {
        this.elapse = this.time;
        this.startedAt = null;
        this.playing = false;
        this.dispatch("stop");
    }
    /**
     * 获取时间
     *
     * @author 张卓诚
     * @returns
     * @memberof Clock
     */
    getTime() {
        if (this.startedAt === null) {
            return this.elapse;
        }
        return new Date().getTime() - this.startedAt + this.elapse;
    }
}
//# sourceMappingURL=clock.js.map